export const NumberChartTitleLength = 200;
export const NumberChartDescriptionLength = 200;
export const FolderCardTitleLength = 35;
export const FolderCardDescriptionLength = 44;
export const ReportCardTitleLength = 41;
export const ReportCardDescriptionLength = 59;